import { isEqual } from 'lodash';
export const areArraysDifferents = (firstArray, secondArray) => !isEqual(firstArray, secondArray);
export const getSortedData = (sortedIds, dataSource) => {
    const sortedData = sortedIds
        .map((id) => dataSource.find((datum) => datum.id === id))
        .filter((datum) => datum !== undefined);
    return sortedData;
};
//# sourceMappingURL=utils.js.map